import {
  NOTES_GET,
  NOTE_GET,
} from './reduxConstant';

export const notesGet = (notes) => {
  
  return {
    type: NOTES_GET,
    payload: {
      notes,
    },
  };
};

export const noteGet = (note) => {
  return {
    type: NOTE_GET,
    payload: {
      note,
    },
  };
};
